function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_140",
  "data-name": "Group 140",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "21"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  d: "M3 4h18v2H3zm0 7h18v2H3zm0 7h18v2H3z",
  fill: "#fff"
})));